import _extends from "@babel/runtime-corejs3/helpers/extends";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import classnames from 'classnames';
import { sizes, colors, font, icons, positions, widths, promptTypes } from "../../../enums";
import { whitelistStyles } from "../../core/hoc";
import IsInvertedProvider from "../is-inverted-provider";
import Modal from "../../core/modal";
import Label from "../../core/label";
import Input from "../../core/input";
import Button from "../../core/button";
import Header from "../../core/header/header";
import Checkbox from "../../core/checkbox-like/checkbox";
import Layout from "../../core/layout";
import Icon from "../../core/icon";
var MathProblemCheck = createComponent({
  displayName: 'MathProblemCheck',
  propTypes: {
    onCorrectMathSum: PropTypes.func.isRequired,
    onInvalidMathSum: PropTypes.func.isRequired
  },
  state: {
    _mathProblem: {
      value: function value(props) {
        var param1 = _.random(1, 9);

        var param2 = _.random(1, 9);

        var correctSum = param1 + param2;
        return {
          isSolved: false,
          correctSum: correctSum,
          param1: param1,
          param2: param2,
          userInput: ''
        };
      },
      updater: '_setMathProblem'
    }
  },
  handlers: {
    handleUserInput: function handleUserInput(props) {
      return function (event) {
        var userSum = _.parseInt(event.target.value);

        var isValid = !_.isNaN(userSum) && -1 < userSum && userSum < 100;
        var isSolved = isValid && userSum === props._mathProblem.correctSum;
        isSolved ? props.onCorrectMathSum() : props.onInvalidMathSum();

        props._setMathProblem(_extends({}, props._mathProblem, {
          userInput: isValid ? userSum : '',
          isSolved: isSolved
        }));
      };
    }
  },
  render: function render(props) {
    var inputClassName = classnames({
      'prompt-modal-numeric-input': true,
      'prompt-modal-numeric-input--has-error': props._mathProblem.userInput !== '' && !props._mathProblem.isSolved
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "math-problem"
    }, /*#__PURE__*/React.createElement("div", {
      className: "math-problem__label"
    }, /*#__PURE__*/React.createElement(Label, {
      text: props._mathProblem.param1 + " + " + props._mathProblem.param2 + " = ",
      color: colors.WHITE,
      size: sizes.X6,
      style: {
        padding: 0,
        margin: 0
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "math-problem__input"
    }, /*#__PURE__*/React.createElement(Input, {
      className: inputClassName,
      type: "number",
      value: props._mathProblem.userInput,
      onChange: props.handleUserInput
    })));
  }
});
var PromptModal = createComponent({
  displayName: 'PromptModal',
  propTypes: {
    promptType: PropTypes.oneOf(promptTypes.ALL),
    header: PropTypes.string,
    byline: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    icon: PropTypes.oneOf(icons.ALL),
    mountNode: PropTypes.any,
    isOpen: PropTypes.bool,
    isMathProblemRequired: PropTypes.bool,
    isConfirmationRequired: PropTypes.bool,
    acknowledgeAction: PropTypes.shape({
      onClick: PropTypes.func,
      text: PropTypes.string,
      isDisabled: PropTypes.oneOf([PropTypes.bool, PropTypes.func]),
      start: PropTypes.func,
      success: PropTypes.func,
      failure: PropTypes.func
    }).isRequired,
    cancelAction: PropTypes.shape({
      onClick: PropTypes.func,
      text: PropTypes.string
    }),
    otherAction: PropTypes.shape({
      onClick: PropTypes.func,
      text: PropTypes.string,
      isDisabled: PropTypes.oneOf([PropTypes.bool, PropTypes.func])
    }),
    confirmationLabel: PropTypes.string,
    isFullscreen: PropTypes.bool,
    children: PropTypes.any
  },
  defaultProps: {
    // set whatever defaults are best, or make required
    promptType: promptTypes.INFO,
    header: '',
    byline: '',
    icon: null,
    mountNode: undefined,
    // for mounting in another modal
    isOpen: false,
    cancelAction: null,
    otherAction: null,
    isMathProblemRequired: false,
    isConfirmationRequired: false,
    confirmationLabel: 'I confirm my action.',
    isFullscreen: false,
    children: undefined
  },
  lifecycles: {
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.isOpen && !nextProps.isOpen) this.props.resetIsConfirmed();
    }
  },
  state: {
    isMathCorrect: {
      value: false,
      updater: function updater(_updater) {
        return {
          setCorrectMathSum: function setCorrectMathSum() {
            return _updater(true);
          },
          setInvalidMathSum: function setInvalidMathSum() {
            return _updater(false);
          }
        };
      }
    },
    isConfirmed: {
      value: false,
      updater: function updater(_updater2) {
        return {
          toggleIsConfirmed: function toggleIsConfirmed() {
            return _updater2(function (isConfirmed) {
              return !isConfirmed;
            });
          },
          resetIsConfirmed: function resetIsConfirmed() {
            return _updater2(function (isConfirmed) {
              return false;
            });
          }
        };
      }
    }
  },
  render: function render(p) {
    var _classnames;

    var backgroundType = null;

    switch (p.promptType) {
      case promptTypes.WARNING:
        p.icon = p.icon || icons.WARNING;
        backgroundType = 'warning';
        break;

      case promptTypes.INFO:
        p.icon = p.icon || icons.INFO;
        backgroundType = 'info';
        break;

      case promptTypes.ERROR:
        //there should be an icon with the circle coming to CK in the nearby future
        p.icon = p.icon || icons.WARNING;
        backgroundType = 'error';
        break;

      default:
        p.icon = p.icon || icons.INFO;
        backgroundType = 'info';
        break;
    }

    var _cls = classnames('ck', 'prompt-modal', (_classnames = {}, _classnames["background-" + backgroundType] = backgroundType, _classnames));

    var contentClassName = classnames('prompt-modal__content', backgroundType);
    return /*#__PURE__*/React.createElement(Modal, {
      hasCloseIcon: false,
      showModal: p.isOpen,
      isFullscreen: true,
      isSolid: true,
      mountNode: p.mountNode,
      onClose: p.onCancel,
      closeOnEscape: false
    }, /*#__PURE__*/React.createElement("div", {
      className: _cls
    }, /*#__PURE__*/React.createElement(Layout, {
      isFluidHeight: true,
      padding: {
        vertical: null,
        horizontal: null
      },
      columnStyles: {
        backgroundColor: p.isFullscreen ? '' : colors.ACCENT
      }
    }, /*#__PURE__*/React.createElement(Layout.Column, {
      verticalAlign: positions.alignColumns.MIDDLE
    }, /*#__PURE__*/React.createElement("div", {
      className: contentClassName,
      style: p.style
    }, /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Layout.Row, null, /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.FOUR,
      textAlign: positions.RIGHT
    }, /*#__PURE__*/React.createElement(Icon, {
      name: p.icon,
      color: colors.WHITE
    })), /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.TEN
    }, /*#__PURE__*/React.createElement(Layout, {
      columns: widths.ONE
    }, !p.children ? /*#__PURE__*/React.createElement(Header, {
      text: p.header,
      size: sizes.X7,
      byline: p.byline,
      color: colors.WHITE,
      font: {
        emphasis: font.emphasis.NORMAL,
        family: font.families.CUSTOM,
        weight: font.weights.BOLD
      }
    }) : p.children, p.isConfirmationRequired ? /*#__PURE__*/React.createElement(IsInvertedProvider, {
      isInverted: false
    }, /*#__PURE__*/React.createElement(Checkbox, {
      label: p.confirmationLabel,
      value: "0",
      isChecked: p.isConfirmed,
      onChange: p.toggleIsConfirmed,
      gutterSize: sizes.SMALL
    })) : null, p.isMathProblemRequired ? /*#__PURE__*/React.createElement(MathProblemCheck, {
      onInvalidMathSum: p.setInvalidMathSum,
      onCorrectMathSum: p.setCorrectMathSum
    }) : null))), /*#__PURE__*/React.createElement(Layout.Row, {
      columns: widths.TWO
    }, /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.FOURTEEN
    }, /*#__PURE__*/React.createElement(Button.Group, {
      isFluid: false // the enum for this is : directions.H , however that value is "horizontally", and not
      // "horizontal" which is the value expected by the Button.Group component
      ,
      layout: "horizontal",
      "float": positions.RIGHT
    }, p.cancelAction ? /*#__PURE__*/React.createElement(Button.Primary, {
      text: p.cancelAction.text,
      color: colors.WHITE,
      onClick: p.cancelAction.onClick
    }) : null, p.otherAction ? /*#__PURE__*/React.createElement(Button.Primary, {
      text: p.otherAction.text,
      color: colors.WHITE,
      onClick: p.otherAction.onClick,
      isDisabled: p.otherAction.isDisabled
    }) : null, !!p.acknowledgeAction.start ? /*#__PURE__*/React.createElement(Button.WithAnimation, {
      actions: {
        start: p.acknowledgeAction.start,
        success: p.acknowledgeAction.success,
        failure: p.acknowledgeAction.failure
      }
    }, /*#__PURE__*/React.createElement(Button.Primary, {
      isSolid: true,
      isDisabled: p.acknowledgeAction.isDisabled || !canAcknowledge(p),
      text: p.acknowledgeAction.text,
      color: colors.WHITE,
      onClick: p.acknowledgeAction.onClick
    })) : null, !p.acknowledgeAction.start ? /*#__PURE__*/React.createElement(Button.Primary, {
      isSolid: true,
      isDisabled: p.acknowledgeAction.isDisabled || !canAcknowledge(p),
      text: p.acknowledgeAction.text,
      color: colors.WHITE,
      onClick: p.acknowledgeAction.onClick
    }) : null)))))))));
  }
});

function canAcknowledge(props) {
  return (!props.isConfirmationRequired || props.isConfirmed) && (!props.isMathProblemRequired || props.isMathCorrect);
}

export default whitelistStyles()(PromptModal);
//# sourceMappingURL=index.js.map